<template>
  <v-autocomplete
    :value="value"
    outlined
    :multiple="multiple"
    :chips="multiple"
    :loading="loading"
    :search-input.sync="search"
    :label="label"
    :hint="hint"
    persistent-hint
    :items="items"
    item-value="id"
    item-text="name"
    hide-details="auto"
    clearable
    hide-no-data
    :cache-items="multiple"
    @input="$emit('input', $event)"
  />
</template>

<script>
import _ from "lodash";

export default {
  props: {
    value: {
      type: Array,
      required: false,
    },
    initialStudents: {
      type: Array,
      required: false,
    },
    label: {
      type: String,
      required: false,
      default: "Select Student",
    },
    hint: {
      type: String,
      required: false,
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      students: [],
      search: null,
      debouncedUpdateStudents: null,
    };
  },
  watch: {
    search(value) {
      if (value == null || value === "" || value?.length < 2) return;
      this.debouncedUpdateStudents();
    },
  },
  created() {
    this.debouncedUpdateStudents = _.debounce(this.updateStudents, 300);
    this.loadInitialStudents();
  },
  computed: {
    items() {
      return this.students.map(student => ({
        id: student.id,
        name: `${student.firstName} ${student.lastName}`,
      }));
    },
  },
  methods: {
    async loadInitialStudents() {
      if (!this.initialStudents) return;
      const response = await this.$axios.get("/student/get-by-ids", {
        params: { ids: this.initialStudents.join(",") },
      });
      // add to current students
      this.students = response.data;
    },
    async updateStudents() {
      this.loading = true;

      try {
        const response = await this.$axios.get("/student", {
          params: {
            activeOnly: false,
            searchTerms: this.search,
            size: 50,
          },
        });
        const content = response.data.content;
        this.students = content ?? [];
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
